import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateDocumentType($companyId: ID!, $attributes: DocumentTypeAttributes!) {
    createDocumentType(companyId: $companyId, attributes: $attributes) {
      documentType {
        id
        ...CreatedDocumentType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedDocumentType on DocumentType {
    id
    name
    dateDue
    dateIssued
    freeagentResource
    xeroResource
    incrementStart
    incremental
    nextNumber
    subject
    crewVisible
    size
    orientation
    documentTypeBlocks { id }
  }
`
